import React, { lazy, Suspense, Component } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import Loading from 'components/shared-components/Loading';
import { APP_PREFIX_PATH, ADMIN_API_BASE_ENDPOINT } from 'configs/AppConfig'
import history from '../../history'
import service from 'auth/FetchInterceptor';
import { getAdminUserData } from 'redux/actions/Auth';

class AppViews extends Component {
    constructor(props) {
        super(props);

        this.state = {
            token: props.token ? props.token : null,
            userData: props.userData ? props.userData : [],
            userAccessData: []
        }
    }

    componentDidMount() {
        if (!this.state.token) {
            this.isAuthenticated()
        } else {
            //this.fetchAdmin();
        }
    }


    isAuthenticated = () => {
        history.push('/auth/login')
        window.location.reload();
    }

    render() {
        const userAccessData = this.state.userData.role_id !== undefined && this.state.userData.role_id.length > 0 ? this.state.userData.role_id[0].role_access : [];

        if (!this.state.token || !userAccessData) {
            this.isAuthenticated()
        }
        
        var role_type =  this.state.userData.role_id[0].role_type === 'default' ? 'default' :  this.state.userData.role_id[0].role_type;

        const customerRoutes = [
            <Route path={`${APP_PREFIX_PATH}/customer`} component={lazy(() => import(`./customer/list-customer`))} />,
            <Route path={`${APP_PREFIX_PATH}/customer_edit`} component={lazy(() => import(`./customer/add-customer`))} />
        ]
        const homeRoutes = [
            <Route path={`${APP_PREFIX_PATH}/home`} component={lazy(() => import(`./home`))} />
        ]

        const approveRoutes = [
            userAccessData.includes('approve_management') || userAccessData.includes('approve_list') || role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/approve/lists`} component={lazy(() => import(`./approve`))} /> : null,
            userAccessData.includes('approve_management') || userAccessData.includes('approve_mgmt') || role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/approve/management`} component={lazy(() => import(`./approve/management`))} /> : null,
        ]

        const adminUserRoutes = [
            userAccessData.includes('users-admins') || userAccessData.includes('users') || role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/users/admins/add`} component={lazy(() => import(`./users/admins/AdminAdd`))} /> : null,
            userAccessData.includes('users-admins') || userAccessData.includes('users') || role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/users/admins/update`} component={lazy(() => import(`./users/admins/AdminAdd`))} /> : null ,
            userAccessData.includes('users-admins') || userAccessData.includes('users') || role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/users/admins/access`} component={lazy(() => import(`./users/admins/AdminAccess`))} /> : null ,
            userAccessData.includes('users-admins') || userAccessData.includes('users') || role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/users/admins/list`} component={lazy(() => import(`./users/admins/AdminList`))} /> : null,
        ]

        const adminUserRoleRoutes = [
            userAccessData.includes('users-role') || userAccessData.includes('users') || role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/users/role/list`} component={lazy(() => import(`./users/roles/list-role`))} /> : null ,
            userAccessData.includes('users-role') || userAccessData.includes('users') || role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/users/role/add`} component={lazy(() => import(`./users/roles/add-role`))} /> : null,
            userAccessData.includes('users-role') || userAccessData.includes('users') || role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/users/role/edit`} component={lazy(() => import(`./users/roles/add-role`))} /> : null,
        ]


        const shopRoutes = [
            userAccessData.includes('shop_management') ||  userAccessData.includes('shop-list') || role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/shop/list`} component={lazy(() => import(`./shops/list-shop`))} /> : null ,
            userAccessData.includes('shop_management') ||  userAccessData.includes('shop-list') || role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/shop/add`} component={lazy(() => import(`./shops/add-shop`))} /> : null ,
            userAccessData.includes('shop_management') ||  userAccessData.includes('shop-list') || role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/shop/edit`} component={lazy(() => import(`./shops/add-shop`))} /> : null,
            
            //main shop route
            userAccessData.includes('shop_management')  || userAccessData.includes('main_shop')  || role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/shop/main_shop`} component={lazy(() => import(`./shops/list-main-shop`))} /> : null,
            userAccessData.includes('shop_management')  || userAccessData.includes('main_shop') || role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/shop/main_shop_add`} component={lazy(() => import(`./shops/add-main-shop`))} /> : null,
            userAccessData.includes('shop_management')  || userAccessData.includes('main_shop') || role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/shop/main_shop_edit`} component={lazy(() => import(`./shops/add-main-shop`))} />: null,
            
            //shop group route
            userAccessData.includes('shop_management')  || userAccessData.includes('group_list')  || role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/shop/group_list`} component={lazy(() => import(`./shops/list-shop-group`))} /> : null,
            userAccessData.includes('shop_management')  || userAccessData.includes('group_list') || role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/shop/group_add`} component={lazy(() => import(`./shops/add-shop-group`))} /> : null,
            userAccessData.includes('shop_management')  || userAccessData.includes('group_list') || role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/shop/group_edit`} component={lazy(() => import(`./shops/add-shop-group`))} />: null,

            //Shop visit route
            userAccessData.includes('shop_management')  || userAccessData.includes('shop_visit')  || role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/shop/shop_visit`} component={lazy(() => import(`./shops/list-shop-visit`))} /> : null,
            userAccessData.includes('shop_management')  || userAccessData.includes('shop_visit') || role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/shop/shop_visit_add`} component={lazy(() => import(`./shops/add-shop-visit`))} /> : null,
            userAccessData.includes('shop_management')  || userAccessData.includes('shop_visit') || role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/shop/shop_visit_edit`} component={lazy(() => import(`./shops/add-shop-visit`))} />: null,
            
            //Shop Branch Route
            userAccessData.includes('shop_management') ||  userAccessData.includes('branch-list') || role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/shop/branch`} component={lazy(() => import(`./branch/list-branch`))} /> : null ,
            userAccessData.includes('shop_management') ||  userAccessData.includes('branch-list') || role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/shop/branch_add`} component={lazy(() => import(`./branch/add-branch`))} /> : null ,
            userAccessData.includes('shop_management') ||  userAccessData.includes('branch-list') || role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/shop/branch_edit`} component={lazy(() => import(`./branch/add-branch`))} /> : null,
        
            //Shop Product Route
            userAccessData.includes('shop_management') ||  userAccessData.includes('products-list') || role_type === 'default' ?
            <Route exact path={`${APP_PREFIX_PATH}/shop/product`} component={lazy(() => import(`./products/list-product`))} />: null ,
            userAccessData.includes('shop_management') ||  userAccessData.includes('products-list') || role_type === 'default' ?
            <Route exact path={`${APP_PREFIX_PATH}/shop/product_add`} component={lazy(() => import(`./products/add-product`))} />: null ,
            userAccessData.includes('shop_management') ||  userAccessData.includes('products-list') || role_type === 'default' ?
            <Route exact path={`${APP_PREFIX_PATH}/shop/product_edit`} component={lazy(() => import(`./products/add-product`))} />: null ,
        ]

        const expensesRoutes = [
            userAccessData.includes('manage_expenses') ||  userAccessData.includes('expenses_list') || role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/expenses/list`} component={lazy(() => import(`./expenses/list-expenses`))} /> : null,

            userAccessData.includes('manage_expenses') ||  userAccessData.includes('expenses_list') || role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/expenses/add`} component={lazy(() => import(`./expenses/add-expenses`))} /> : null,

            userAccessData.includes('manage_expenses') ||  userAccessData.includes('expenses_list') || role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/expenses/edit`} component={lazy(() => import(`./expenses/add-expenses`))} />: null
        ]

        const custodyRoutes = [
            userAccessData.includes('staff_custody') || userAccessData.includes('manage_staff') ||role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/custody/list`} component={lazy(() => import(`./custody/list-custody`))} /> : null,

            userAccessData.includes('staff_custody') ||  userAccessData.includes('manage_staff') || role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/custody/add`} component={lazy(() => import(`./custody/add-custody`))} /> : null,

            userAccessData.includes('staff_custody') ||  userAccessData.includes('manage_staff') || role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/custody/edit`} component={lazy(() => import(`./custody/add-custody`))} />: null
        ]

        const supplierRoutes = [
            userAccessData.includes('manage_supplier') || userAccessData.includes('manage_expenses') || role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/supplier/list`} component={lazy(() => import(`./purchasing_suppliers/list-supplier`))} /> : null,

            userAccessData.includes('manage_supplier') || userAccessData.includes('manage_expenses') ||  role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/supplier/add`} component={lazy(() => import(`./purchasing_suppliers/add-supplier`))} /> : null,

            userAccessData.includes('manage_supplier') || userAccessData.includes('manage_expenses') || role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/supplier/edit`} component={lazy(() => import(`./purchasing_suppliers/add-supplier`))} />: null
        ]

        //if need to fix permission here
        const allReminderList = [
            userAccessData.includes('manage_staff') || userAccessData.includes('staff_reminders') || role_type === 'default' ?
                <Route path={`${APP_PREFIX_PATH}/reminders/staff`} component={lazy(() => import(`./reminders/staff-reminders`))} /> : null,

            userAccessData.includes('car_management') || userAccessData.includes('car_reminders') || role_type === 'default' ?
                <Route path={`${APP_PREFIX_PATH}/reminders/car`} component={lazy(() => import(`./reminders/car-reminders`))} /> : null,

            userAccessData.includes('all_reminder') || userAccessData.includes('car_reminders') || role_type === 'default' ?
                <Route path={`${APP_PREFIX_PATH}/all_reminder`} component={lazy(() => import(`./reminders/all-reminders`))} /> : null,

            userAccessData.includes('driver_management') || userAccessData.includes('driver_reminders') || role_type === 'default' ?
                <Route path={`${APP_PREFIX_PATH}/reminders/driver`} component={lazy(() => import(`./reminders/driver-reminders`))} /> : null,

            userAccessData.includes('car_management') || userAccessData.includes('car_accident_reminder') || role_type === 'default' ?
                <Route path={`${APP_PREFIX_PATH}/reminders/car_accident`} component={lazy(() => import(`./reminders/car-accident-reminders`))} /> : null,
        ];

        const staffList = [
            <Route path={`${APP_PREFIX_PATH}/staff/lists`} component={lazy(() => import(`./staff/list-staff`))} />,
            <Route path={`${APP_PREFIX_PATH}/staff/add`} component={lazy(() => import(`./staff/add-staff`))} />,
            <Route path={`${APP_PREFIX_PATH}/staff/edit`} component={lazy(() => import(`./staff/add-staff`))} />,
        ]
        const staffInvoice = [
            <Route path={`${APP_PREFIX_PATH}/staff/payroll`} component={lazy(() => import(`./staff/staff-invoice`))} />,
        ]

        const staffRoutes = [
            userAccessData.includes('manage_staff') || userAccessData.includes('staff_lists') || role_type === 'default' ? staffList : null,
            userAccessData.includes('manage_staff') || userAccessData.includes('staff_invoice') || role_type === 'default' ? staffInvoice : null,
        ];


        const productTypeList = [
            <Route exact path={`${APP_PREFIX_PATH}/products/list-type`} component={lazy(() => import(`./products/list-type`))} />,
            <Route exact path={`${APP_PREFIX_PATH}/products/add-type`} component={lazy(() => import(`./products/add-type`))} />,
            <Route exact path={`${APP_PREFIX_PATH}/products/edit-type`} component={lazy(() => import(`./products/add-type`))} />,
        ]
        const productSizeList = [
            <Route exact path={`${APP_PREFIX_PATH}/products/list-size`} component={lazy(() => import(`./products/list-size`))} />,
            <Route exact path={`${APP_PREFIX_PATH}/products/add-size`} component={lazy(() => import(`./products/add-size`))} />,
            <Route exact path={`${APP_PREFIX_PATH}/products/edit-size`} component={lazy(() => import(`./products/add-size`))} />,
        ]
        const productChoiceList = [
            <Route exact path={`${APP_PREFIX_PATH}/products/list-choice`} component={lazy(() => import(`./products/list-choice`))} />,
            <Route exact path={`${APP_PREFIX_PATH}/products/add-choice`} component={lazy(() => import(`./products/add-choice`))} />,
            <Route exact path={`${APP_PREFIX_PATH}/products/edit-choice`} component={lazy(() => import(`./products/add-choice`))} />,
        ]

        const productsRoutes = [
            userAccessData.includes('product-type') || userAccessData.includes('shop_management') || role_type === 'default' ? productTypeList : null,
            userAccessData.includes('product-size') || userAccessData.includes('shop_management') || role_type === 'default' ? productSizeList : null,
            userAccessData.includes('product-choice') || userAccessData.includes('shop_management') || role_type === 'default' ? productChoiceList : null
        ];

        const RunningOrderLists = React.lazy(() => import('./orders/lists-running_order'));
        const CancelledOrderLists = React.lazy(() => import('./orders/lists-cancelled_order'));
        const DeliveredOrderLists = React.lazy(() => import('./orders/lists-delivered_order'));

        const ordersRoutes = [
            userAccessData.includes('order-list') || userAccessData.includes('order_management') || role_type === 'default' ?
                <RunningOrderLists path={`${APP_PREFIX_PATH}/orders/lists`} socket={this.props.socket} /> : null,

            userAccessData.includes('cancelled-lists') || userAccessData.includes('order_management') || role_type === 'default' ?
                <CancelledOrderLists path={`${APP_PREFIX_PATH}/orders/cancelled`} socket={this.props.socket} /> : null,

            userAccessData.includes('delivered-lists') || userAccessData.includes('order_management') || role_type === 'default' ?
                <DeliveredOrderLists path={`${APP_PREFIX_PATH}/orders/delivered`} socket={this.props.socket} /> : null,

            userAccessData.includes('order_management') || role_type === 'default' ?
                <Route path={`${APP_PREFIX_PATH}/orders/route_map`} component={lazy(() => import(`./orders/order_simulation_map`))} /> : null,
        ];

        const reportRoutes = [
            userAccessData.includes('shop_report') || userAccessData.includes('report_management') || role_type === 'default' ?
                <Route path={`${APP_PREFIX_PATH}/report/shop`} component={lazy(() => import(`./reports/shop`))} /> : null,

            userAccessData.includes('driver_report') || userAccessData.includes('driver_management') || role_type === 'default' ?
                <Route path={`${APP_PREFIX_PATH}/report/driver-profitability`} component={lazy(() => import(`./reports/delivered`))} /> : null,
                
            userAccessData.includes('car-profitability') || userAccessData.includes('report_management') || role_type === 'default' ?
                <Route path={`${APP_PREFIX_PATH}/report/car-profitability`} component={lazy(() => import(`./reports/car_profitibility_report`))} /> : null,

            userAccessData.includes('client-profitability')  || userAccessData.includes('report_management') || role_type === 'default' ?
                <Route path={`${APP_PREFIX_PATH}/report/client-profitability`} component={lazy(() => import(`./reports/client_profitibility_report`))} /> : null

        ]

        const carInfo = [
            <Route exact path={`${APP_PREFIX_PATH}/vehicle/list-car`} component={lazy(() => import(`./cars/list-car`))} />,
            <Route exact path={`${APP_PREFIX_PATH}/vehicle/add`} component={lazy(() => import(`./cars/add-car`))} />,
            <Route exact path={`${APP_PREFIX_PATH}/vehicle/edit`} component={lazy(() => import(`./cars/add-car`))} />
        ]

        const carMaintenanceBill = [
            <Route exact path={`${APP_PREFIX_PATH}/vehicle/list-maintenance-bill`} component={lazy(() => import(`./cars/list-maintenance-bill`))} />,
            <Route exact path={`${APP_PREFIX_PATH}/vehicle/add-maintenance-bill`} component={lazy(() => import(`./cars/add-maintenance-bill`))} />,
            <Route exact path={`${APP_PREFIX_PATH}/vehicle/edit-bill`} component={lazy(() => import(`./cars/add-maintenance-bill`))} />
        ]

        const carClaim = [
            <Route exact path={`${APP_PREFIX_PATH}/vehicle/list-claim`} component={lazy(() => import(`./cars/list-claim`))} />,
            <Route exact path={`${APP_PREFIX_PATH}/vehicle/add-claim`} component={lazy(() => import(`./cars/add-claim`))} />,
            <Route exact path={`${APP_PREFIX_PATH}/vehicle/edit-claim`} component={lazy(() => import(`./cars/add-claim`))} />,
        ]

        const carFuel = [
            <Route exact path={`${APP_PREFIX_PATH}/vehicle/list-fuel`} component={lazy(() => import(`./cars/list-fuel`))} />,
            <Route exact path={`${APP_PREFIX_PATH}/vehicle/add-fuel`} component={lazy(() => import(`./cars/add-fuel`))} />,
            <Route exact path={`${APP_PREFIX_PATH}/vehicle/edit-fuel`} component={lazy(() => import(`./cars/add-fuel`))} />,
        ]

        const accident = [
            <Route exact path={`${APP_PREFIX_PATH}/vehicle/list-accident`} component={lazy(() => import(`./cars/list-accident`))} />,
            <Route exact path={`${APP_PREFIX_PATH}/vehicle/add-accident`} component={lazy(() => import(`./cars/add-accident`))} />,
            <Route exact path={`${APP_PREFIX_PATH}/vehicle/edit-accident`} component={lazy(() => import(`./cars/add-accident`))} />,
        ];
       
        const maintenanceReminder = [
            <Route exact path={`${APP_PREFIX_PATH}/vehicle/list-maintenance-reminder`} component={lazy(() => import(`./cars/list-maintenance-reminder`))} />,
            <Route exact path={`${APP_PREFIX_PATH}/vehicle/add-maintenance-reminder`} component={lazy(() => import(`./cars/add-maintenance-reminder`))} />,
            <Route exact path={`${APP_PREFIX_PATH}/vehicle/edit-maintenance-reminder`} component={lazy(() => import(`./cars/add-maintenance-reminder`))} />,
        ];


        const carRoutes = [
            userAccessData.includes('car-info') || userAccessData.includes('car_management') || role_type === 'default' ? carInfo : null,
            userAccessData.includes('car-maintenance-bill') || userAccessData.includes('car_management') || role_type === 'default' ? carMaintenanceBill : null,
            userAccessData.includes('car-fuel') || userAccessData.includes('car_management') || role_type === 'default' ? carFuel : null,
            userAccessData.includes('car-claim') || userAccessData.includes('car_management') || role_type === 'default' ? carClaim : null,
            userAccessData.includes('car-accident') || userAccessData.includes('car_management') || role_type === 'default' ? accident : null,           
            userAccessData.includes('car-maintenance-bill') || userAccessData.includes('car_management') || role_type === 'default' ? maintenanceReminder : null,
        ];

        const driverListRoutes = [
            userAccessData.includes('driver_list') || userAccessData.includes('driver_management') || role_type === 'default' ?
            <Route exact path={`${APP_PREFIX_PATH}/drivers/list`} component={lazy(() => import(`./drivers/list-driver`))} /> : null ,
            userAccessData.includes('driver_list') || userAccessData.includes('driver_management') || role_type === 'default' ?
            <Route exact path={`${APP_PREFIX_PATH}/drivers/add-driver`} component={lazy(() => import(`./drivers/add-driver`))} /> : null,
            userAccessData.includes('driver_list') || userAccessData.includes('driver_management') || role_type === 'default' ?
            <Route exact path={`${APP_PREFIX_PATH}/drivers/edit-driver`} component={lazy(() => import(`./drivers/add-driver`))} /> : null
        ]

        const driverReportListRoutes = [
            userAccessData.includes('driver_follow_report') || userAccessData.includes('driver_management') || role_type === 'default' ?
            <Route exact path={`${APP_PREFIX_PATH}/drivers/driver-follow-report`} component={lazy(() => import(`./drivers/list-driver-report`))} /> : null ,
            userAccessData.includes('driver_follow_report') || userAccessData.includes('driver_management') || role_type === 'default' ?
            <Route exact path={`${APP_PREFIX_PATH}/drivers/add-driver-report`} component={lazy(() => import(`./drivers/add-driver-report`))} /> : null,
            userAccessData.includes('driver_follow_report') || userAccessData.includes('driver_management') || role_type === 'default' ?
            <Route exact path={`${APP_PREFIX_PATH}/drivers/edit-driver-report`} component={lazy(() => import(`./drivers/add-driver-report`))} /> : null
        ]

        const additionalRoutes = [
            <Route exact path={`${APP_PREFIX_PATH}/drivers/additional`} component={lazy(() => import(`./drivers/list-additional`))} />,
            <Route exact path={`${APP_PREFIX_PATH}/drivers/additional_deduction`} component={lazy(() => import(`./drivers/add-additional`))} />,
        ];

        const driverInvoiceRoutes = [
            <Route path={`${APP_PREFIX_PATH}/drivers/payroll`} component={lazy(() => import(`./drivers/driver-invoice`))} />,
        ]

        const driverRoutes = [
            userAccessData.includes('driver_management') || userAccessData.includes('driver_list') || role_type === 'default' ? driverListRoutes : null,
            userAccessData.includes('driver_management') || userAccessData.includes('additional_deduction') || role_type === 'default' ? additionalRoutes : null,
            userAccessData.includes('driver_management') || userAccessData.includes('driver_invoice') || role_type === 'default' ? driverInvoiceRoutes : null,
            userAccessData.includes('driver_management') || userAccessData.includes('driver_follow_report') || role_type === 'default' ? driverReportListRoutes : null,
        ];

        const deviceAdd = [
            <Route path={`${APP_PREFIX_PATH}/device/list`} component={lazy(() => import(`./device/list-device`))} />,
            <Route path={`${APP_PREFIX_PATH}/device/add`} component={lazy(() => import(`./device/add-device`))} />,
            <Route path={`${APP_PREFIX_PATH}/device/edit`} component={lazy(() => import(`./device/add-device`))} />,
            <Route path={`${APP_PREFIX_PATH}/device/buy`} component={lazy(() => import(`./device/buy-device`))} />
        ]
        const DeviceRoutes = [
            userAccessData.includes('add_device') || userAccessData.includes('device_management') || role_type === 'default' ? deviceAdd : null,
            userAccessData.includes('device_trip') || userAccessData.includes('device_management') || role_type === 'default' ?
                <Route path={`${APP_PREFIX_PATH}/device/trip`} component={lazy(() => import(`./device/trip/index`))} />
                : null,
            userAccessData.includes('device_history') || userAccessData.includes('device_management') || role_type === 'default' ?
                <Route path={`${APP_PREFIX_PATH}/device/history`} component={lazy(() => import(`./device/history/index`))} />
                : null,
            userAccessData.includes('device_notification') || userAccessData.includes('device_management') || role_type === 'default' ?
                <Route path={`${APP_PREFIX_PATH}/device/notification`} component={lazy(() => import(`./device/notification/device_notification`))} />
                : null,
            userAccessData.includes('device_notification') || userAccessData.includes('device_management') || role_type === 'default' ?
                <Route path={`${APP_PREFIX_PATH}/device/notification_detail`} component={lazy(() => import(`./device/notification/device_notification_detail`))} />
                : null,
            userAccessData.includes('car_notification') || userAccessData.includes('device_management') || role_type === 'default' ?
                <Route path={`${APP_PREFIX_PATH}/device/car_notification`} component={lazy(() => import(`./device/notification/car_notification`))} />
                : null,
        ]

        const settingRoutes = [
            userAccessData.includes('setting') || role_type === 'default' ?
                <Route path={`${APP_PREFIX_PATH}/setting`} component={lazy(() => import(`./setting/index`))} /> : null
        ]
        const attendanceRoutes = [
            userAccessData.includes('attendance')  || role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/attendance`} component={lazy(() => import(`./attendance/list-attendance`))} userData={this.state.userData}/> : null
        ]

        const clientVisitRoutes = [
            userAccessData.includes('client_visit')  || role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/client_visit/list`} component={lazy(() => import(`./client_visit/list-client-visit`))} /> : null,

            userAccessData.includes('client_visit') || role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/client_visit/add`} component={lazy(() => import(`./client_visit/add-client-visit`))} /> : null,

            userAccessData.includes('client_visit') || role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/client_visit/edit`} component={lazy(() => import(`./client_visit/add-client-visit`))} />: null
        ]

        const optionsRoutes = [
            userAccessData.includes('manage_expenses') ||  userAccessData.includes('manage_options') || role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/options/list`} component={lazy(() => import(`./options/list-options`))} /> : null,

            userAccessData.includes('manage_expenses') ||  userAccessData.includes('manage_options') || role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/options/add`} component={lazy(() => import(`./options/add-options`))} /> : null,

            userAccessData.includes('manage_expenses') ||  userAccessData.includes('manage_options') || role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/options/edit`} component={lazy(() => import(`./options/add-options`))} />: null
        ]

        const potentialClientsRoutes = [
            userAccessData.includes('sales_potential_clients') ||  role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/sales_potential_clients`} component={lazy(() => import(`./sales_potential_clients/list-leads`))} /> : null,

            userAccessData.includes('sales_potential_clients') || role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/sales_potential_clients_add`} component={lazy(() => import(`./sales_potential_clients/add-leads`))} /> : null,

            userAccessData.includes('sales_potential_clients') || role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/sales_potential_clients_edit`} component={lazy(() => import(`./sales_potential_clients/add-leads`))} />: null
        ]


        const paymentOrderRoutes = [
            userAccessData.includes('payment_order') ||  role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/payment_order`} component={lazy(() => import(`./approve/payment-order`))} /> : null,
        ]
        const expenseReportRoutes = [
            userAccessData.includes('monthly_expenses_report') ||  role_type === 'default' ?
            <Route path={`${APP_PREFIX_PATH}/monthly_expenses_report`} component={lazy(() => import(`./expenses/month_wise_expenses_report`))} /> : null,
        ]

        const SocketList = React.lazy(() => import('./socket/index'));
        return (
            <Suspense fallback={<Loading cover="content" />}>

                <Switch>
                    {
                        // DASHBOARD PATH
                        userAccessData.includes('home') || userAccessData.length == 0 || role_type === 'default' ? homeRoutes : null
                    }
                    {
                        // CUSTOMER PATH
                        userAccessData.includes('customer') || userAccessData.includes('customer_management') || userAccessData.length == 0 || role_type === 'default' ? customerRoutes : null
                    }
                    {
                        approveRoutes
                    }
                    {
                        adminUserRoutes
                    }
                    {
                        allReminderList
                    }
                    {
                        adminUserRoleRoutes
                    }                  
                    {
                        productsRoutes
                    }
                    {
                        expensesRoutes
                    }
                    {
                        custodyRoutes
                    }                
                    {
                        supplierRoutes
                    }
                    {
                        staffRoutes
                    }
                    {
                        ordersRoutes
                    }
                    {
                        reportRoutes
                    }
                    {
                        carRoutes
                    }
                    {
                        driverRoutes
                    }
                    {
                        DeviceRoutes
                    }                                  
                    {
                        settingRoutes
                    }
                    {
                        clientVisitRoutes
                    }
                    {
                        attendanceRoutes
                    }                  
                    {
                        optionsRoutes
                    }
                    {
                        shopRoutes 
                    }
                    {
                        paymentOrderRoutes 
                    }
                    {
                        potentialClientsRoutes 
                    }
                    {
                        expenseReportRoutes 
                    }

                    <SocketList path={`${APP_PREFIX_PATH}/socket`} socket={this.props.socket} />
                    <Route path={`${APP_PREFIX_PATH}/error`} component={lazy(() => import(`./errors/error-page-1`))} />

                    {
                        userAccessData.includes('home') || userAccessData.length == 0 || role_type === 'default'?
                            <Route path={`${APP_PREFIX_PATH}`} component={lazy(() => import(`./home`))} /> :
                            <Route path={`${APP_PREFIX_PATH}`} component={lazy(() => import(`./home/default`))} />
                    }

                    <Redirect from={`${APP_PREFIX_PATH}`} to={`${APP_PREFIX_PATH}/error/`} />

                </Switch>


            </Suspense>
        )
    }
}

const mapStateToProps = ({ theme, auth }) => {
    const { locale, direction } = theme;
    const { token, userData } = auth;
    return { locale, token, userData, direction }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getAdminUserData: (array) => dispatch(getAdminUserData(array))
    }
}

export default React.memo(connect(mapStateToProps, mapDispatchToProps)(AppViews));
